import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {Store} from '@ngrx/store';
import {ADDED_WHEN_DIALOG_OPENS, DialogCloser} from '@aviary/dialogs/base-dialog/base-dialog.types';
import {ConfirmationDialog, ConfirmationDialogDefinition} from '@aviary/dialogs/confirmation-dialog/confirmation-dialog.types';
import {ConfirmationDialogComponent} from '@aviary/dialogs/confirmation-dialog/confirmation-dialog.component';
import {RouterActions} from '@store/aviary/aviary.adapter';
import {OutlinedButtonComponent} from '@aviary/buttons/outlined-button/outlined-button.component';
import {FilledButtonComponent} from '@aviary/buttons/filled-button/filled-button.component';

@Component({
  selector: 'px-create-account-dialog',
  template: `
    <mx-confirmation-dialog [definition]="dialogDefinition" [showConfirmButton]="false" [showCancelButton]="false" [showAdditionalActionButtons]="true">
      <ng-container additionalActionButtons>
        <mx-outlined-button label="No" (click)="onClickCreateAccount()"/>
        <mx-filled-button label="Yes, I have a library card" (click)="onClickLookupAccount()"/>
      </ng-container>
    </mx-confirmation-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, ConfirmationDialogComponent, OutlinedButtonComponent, FilledButtonComponent]
})
export class CreateAccountDialog implements ConfirmationDialog<undefined> {
  public readonly closeDialog: DialogCloser<undefined> = ADDED_WHEN_DIALOG_OPENS;
  public readonly dialogData = undefined;
  private readonly store = inject(Store);

  public readonly dialogDefinition: ConfirmationDialogDefinition = {
    title: 'Do you have a library card yet?',
    prompt: 'If you visited us in person, you may already have a library card number.'
  };

  public onClickCreateAccount(): void {
    this.store.dispatch(RouterActions.navigateTo('REGISTER'));
    this.closeDialog();
  }

  public onClickLookupAccount(): void {
    this.store.dispatch(RouterActions.navigateTo('REGISTER_EXISTING_CARD'));
    this.closeDialog();
  }
}
